import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { IModal } from "../../stores";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { IAllergen } from "../../stores/allergen";

const AllergenForm = observer(({ show, setShowModal }: IModal) => {
  const { allergenStore } = useStores();
  const { editAllergen, fetchAllergens, saveAllergen } = allergenStore;
  const [allergen, setAllergen] = useState<IAllergen>(
    editAllergen ?? {
      allergenId: 0,
      allergenName: "",
      description: "",
    }
  );
  const [isFormValid, setIsFormValid] = useState(true);
  const isEditRequest = editAllergen != null && editAllergen.allergenId > 0;

  const validateForm = () => {
    const isValid = allergen.allergenName ? true : false;
    setIsFormValid(isValid);
  };

  useEffect(() => {
    validateForm();
  }, [allergen]);

  const submitCallback = useCallback((res: boolean) => {
    if (res) {
      setShowModal(false);
      fetchAllergens();
      ShowAlert.Success(
        `Allergen ${isEditRequest ? "updated" : "added"} successfully.`
      );
    } else {
      ShowAlert.Error("Request failed. Please try again.");
    }
  }, []);

  const handleFormSubmit = () => {
    if (!isFormValid) {
      ShowAlert.Error("One or more field value missing.");
      return;
    }

    saveAllergen(allergen, submitCallback);
  };

  const handleInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = evt.target;
    setAllergen((prev) => ({ ...prev, [id]: value }));
  };

  return (
    <Modal show={show} onHide={() => setShowModal(false)}>
      <ModalHeader closeButton>
        <Modal.Title>
          <h5>{isEditRequest ? "Update" : "Add"} Allergen</h5>
        </Modal.Title>
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="allergenName"
              placeholder="Allergen Name"
              value={allergen.allergenName}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="allergenName">Allergen Name</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="description"
              placeholder="Description"
              value={allergen.description}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="description">Description</label>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-default flex-fill"
          onClick={handleFormSubmit}
          disabled={!isFormValid}
        >
          {isEditRequest ? (
            <>
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              <span>Update</span>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>Add</span>
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
});

export default AllergenForm;
